import { ReturnZodSchema } from "@redotech/redo-model/return";
import { ReturnTableInputSchema } from "@redotech/redo-model/returns/return-table-input-schema";
import {
  OpensearchPaginationCursorSchema,
  PaginationCursorSchema,
} from "@redotech/redo-model/tables/table";

import * as z from "zod/v4";

export const getReturnsPagination = {
  name: "getReturnsPagination" as const,
  input: ReturnTableInputSchema.extend({
    pageNumber: z.number().optional(),
    pageSize: z.number(),
    paginationToken: PaginationCursorSchema.nullish(),
    opensearchToken: OpensearchPaginationCursorSchema.nullish(),
  }),
  output: z.object({
    // this is currently parsed and logged in the handler as a zod schema.
    // TODO: type this once we don't see any errors
    returns: z.array(z.union([ReturnZodSchema, z.any()])),
    total: z.number(),
    paginationToken: PaginationCursorSchema.nullish(),
    opensearchToken: OpensearchPaginationCursorSchema.nullish(),
  }),
};
